import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGiftCardData = params =>
  axios.get(`${API_HOST}/gift-card`, { params, withCredentials: true });

export const addGiftCardData = params =>
  axios.post(`${API_HOST}/gift-card/add`, params, { withCredentials: true });

export const editGiftCardData = (id, params) =>
  axios.put(`${API_HOST}/gift-card/${id}`, params, { withCredentials: true });

export const orderGiftCardData = params =>
  axios.put(`${API_HOST}/gift-card/view-order`, params, {
    withCredentials: true
  });

export const deleteGiftCardData = id =>
  axios.delete(`${API_HOST}/gift-card/${id}`, { withCredentials: true });

export const getCategoriesData = params =>
  axios.get(`${API_HOST}/gift-card/category`, {
    params,
    withCredentials: true
  });
